import { render, staticRenderFns } from "./ManageRole.vue?vue&type=template&id=4625e90e"
import script from "./ManageRole.vue?vue&type=script&lang=js"
export * from "./ManageRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports